import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "wrt-tmp-page"
};
const _hoisted_2 = {
  class: "template-main-header"
};
const _hoisted_3 = {
  class: "template-main-header-circle-wrapper"
};
const _hoisted_4 = {
  class: "template-main-type"
};
const _hoisted_5 = {
  class: "template-main-header-search"
};
const _hoisted_6 = {
  class: "template-content-filter"
};
const _hoisted_7 = {
  class: "category-selector"
};
const _hoisted_8 = {
  class: "template-main"
};
const _hoisted_9 = {
  class: "template-tabs-body"
};
import seachInput from './components/seachInput.vue';
import { ref, onMounted, nextTick, watch } from 'vue';
import myTemplateItem from './components/templateItem.vue';
import templateEditor from './components/templateEditor.vue';
import useTemplateData from '@/hooks/useTemplateData.ts';
import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import { useAuthStore } from '@/pinia';
import { addWordTemplate, updateWordTemplate, deleteWordTemplate, getAppWordTemplate, addOfficialWordTemplate } from '@/request/hotspotTemplate.ts';
export default /*@__PURE__*/_defineComponent({
  __name: 'wrtTmpPage',
  setup(__props) {
    const {
      templateData,
      selectedTypeArr,
      templateLoadFn,
      wordDataTypeDic,
      tradeTypeDic,
      loadTemplateLoadFn,
      changeTemplateTypeFn,
      fetchWordDataTypeDic,
      fetchTradeTypeDic
    } = useTemplateData();
    let authStore = useAuthStore();
    let templateEditorRef = ref(null);
    let activeName = ref('');
    let dialogVisible = ref(false);
    let editAuth = ref(true);
    const selectedType = ref(3);
    watch(() => selectedType.value, belong => {
      if (belong === 3) editAuth.value = authStore.teamBenefitCodes.includes('OFFICIAL_TEMPLATE_EDIT');else editAuth.value = true;
    }, {
      immediate: true
    });
    let handleClickCategory = name => {
      activeName.value = name.paneName;
      templateData.value.trade = name.paneName;
      changeTemplateTypeFn('');
    };
    let addTemplateFn = () => {
      console.log('addOfficialWordTemplate', addOfficialWordTemplate);
      dialogVisible.value = true;
    };
    // 官方团队切换列表
    let selectedTypeFn = async belong => {
      selectedType.value = belong;
      templateData.value.belong = belong;
      changeTemplateTypeFn('');
    };
    let searchFn = async keyword => {
      console.log(keyword, 'keyword');
      templateData.value.keyword = keyword;
      changeTemplateTypeFn('');
    };
    // 查询过滤
    let sumbitFn = async form => {
      await nextTick(() => {
        templateData.value.belong = selectedType.value;
        templateData.value.keyword = form.keyword;
        templateData.value.trade = form.trade;
      });
      changeTemplateTypeFn('');
    };
    // 添加模板
    let submitFormFn = async form => {
      // 如果有id就是编辑修改
      if (form !== null && form !== void 0 && form.id) {
        await updateWordTemplate({
          ...form
        });
      } else {
        // 团队
        if (selectedType.value === 2) await addWordTemplate({
          ...form
        });
        // 官方
        if (selectedType.value === 3) await addOfficialWordTemplate({
          ...form
        });
      }
      ElMessage.success('操作成功');
      dialogVisible.value = false;
      changeTemplateTypeFn('');
    };
    let clickItemFn = async row => {
      // 删除提示词模板
      if (row.type === 'delete') {
        ElMessageBox.confirm('确定删除该模板吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            let {
              data
            } = await deleteWordTemplate(row.id);
            const {
              code,
              msg
            } = data;
            ElMessage({
              type: code == 200 ? 'success' : 'error',
              message: msg
            });
            changeTemplateTypeFn('');
          } catch (error) {}
        }).catch(() => {});
      }
      // 获取App提示词模板详情
      if (row.type === 'edit') {
        await nextTick(() => {
          dialogVisible.value = true;
        });
        let {
          data
        } = await getAppWordTemplate(row.id);
        let refs = templateEditorRef.value;
        // 回显
        refs.setInitDataFn(data.data);
      }
      // 添加
      if (row.type === 'add') {
        let {
          data
        } = await getAppWordTemplate(row.id);
        submitFormFn({
          content: data.data.content,
          description: data.data.description,
          title: data.data.title,
          trade: data.data.trade
        });
      }
    };
    onMounted(async () => {
      templateLoadFn();
      fetchWordDataTypeDic();
      fetchTradeTypeDic(); // 如果需要获取字典数据的话
    });
    return (_ctx, _cache) => {
      const _component_el_segmented = _resolveComponent("el-segmented");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "template-main-header-circle-wrapper-bg"
      }, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "template-main-header-circle-wrapper-bg-2"
      }, [_createElementVNode("div", null, [_createElementVNode("div", {
        class: "template-main-header-circle"
      })]), _createElementVNode("i", {
        class: "ri-color-filter-line template-main-header-circle-wrapper-icon"
      })], -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_segmented, {
        modelValue: selectedType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedType.value = $event),
        options: _unref(selectedTypeArr),
        onChange: _cache[1] || (_cache[1] = $event => _unref(selectedTypeFn)($event))
      }, null, 8, ["modelValue", "options"])]), _createElementVNode("div", _hoisted_5, [_createVNode(seachInput, {
        class: "seach-input",
        onSearch: _unref(searchFn),
        selectedType: selectedType.value
      }, null, 8, ["onSearch", "selectedType"])])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_tabs, {
        size: "default",
        modelValue: _unref(activeName),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(activeName) ? activeName.value = $event : activeName = $event),
        class: "category-tabs-box",
        onTabClick: _unref(handleClickCategory)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tradeTypeDic), category => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: category.value,
            label: category.label,
            name: category.value
          }, null, 8, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onTabClick"])]), _unref(editAuth) ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "add-template-button",
        onClick: _unref(addTemplateFn)
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("新建模板")])),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateData).data, i => {
        return _openBlock(), _createBlock(myTemplateItem, {
          editAuth: _unref(editAuth),
          row: i,
          selectedType: selectedType.value,
          onClickItemFn: type => _unref(clickItemFn)({
            type,
            ...i
          })
        }, null, 8, ["editAuth", "row", "selectedType", "onClickItemFn"]);
      }), 256))])])]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : dialogVisible = $event),
        title: "模板编辑器",
        center: "",
        top: "20px"
      }, {
        default: _withCtx(() => [_unref(dialogVisible) ? (_openBlock(), _createBlock(templateEditor, {
          key: 0,
          ref_key: "templateEditorRef",
          ref: templateEditorRef,
          editAuth: _unref(editAuth),
          onSubmitFormFn: _unref(submitFormFn),
          industryTabs: _unref(tradeTypeDic)
        }, null, 8, ["editAuth", "onSubmitFormFn", "industryTabs"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});